var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 839,
    height: 255,
    viewBox: "0 0 839 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_822",
    "data-name": "Ret\\xE2ngulo 822",
    width: 839,
    height: 255,
    transform: "translate(6121 -1158)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_771",
    "data-name": "Ret\\xE2ngulo 771",
    width: 227.579,
    height: 206.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_771-2",
    "data-name": "Ret\\xE2ngulo 771",
    width: 432.5,
    height: 392.629,
    fill: "#ffc818"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_3",
    "data-name": "Grupo de m\\xE1scara 3",
    transform: "translate(-6121 1158)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(5040 -1986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M2999.363,321.189h-608.09V107.782s318.9-242.509,608.09,0",
    transform: "translate(-1128.818 919.405)",
    fill: "#19227d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(1692.421 878.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M114.218,206.6q-50.969,0-101.938-.006C.655,206.585-.432,204.889.109,193.1A174.157,174.157,0,0,1,17.765,123.22c9.7-19.633,21.3-38.034,37.188-53.742,9.4-9.29,18.907-18.207,29.578-25.919A228.689,228.689,0,0,1,200.646.568C206.774.007,212.965.081,219.13,0c5.722-.076,8.013,3.536,8.361,8.608.242,3.543-.093,7.122-.1,10.685q-.062,88.037-.117,176.076c-.01,9.71-1.522,11.188-11.122,11.194q-50.969.032-101.938.009Z",
    transform: "translate(0 7)",
    fill: "#de2039"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(1081.5 864.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11-2",
    "data-name": "Grupo 11",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5-2",
    "data-name": "Caminho 5",
    d: "M215.434,392.624q96.863,0,193.726-.011c22.094-.011,24.16-3.234,23.133-25.648-2.133-46.642-12.992-91.183-33.555-132.794-18.438-37.312-40.478-72.282-70.674-102.134-17.863-17.654-35.932-34.6-56.21-49.258a439.9,439.9,0,0,0-97.447-53.31C134.4,13.737,93.515,4.947,51.184,1.079,39.539.013,27.772.154,16.057,0,5.181-.141.828,6.722.167,16.361-.294,23.094.343,29.9.348,36.666q.118,167.31.222,334.622c.019,18.454,2.892,21.262,21.137,21.273q96.863.061,193.726.016Z",
    transform: "translate(0.001 0)",
    fill: "#ffc818"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.bb4821f7040478245951e6f8bf1c3ad6.svg";
export { ForwardRef as ReactComponent };